"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOAD_ACCOUNTS = 'LOAD_ACCOUNTS';
exports.LOAD_ACCOUNT = 'LOAD_ACCOUNT';
exports.CREATE_ACCOUNT = 'CREATE_ACCOUNT';
exports.UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
exports.DELETE_ACCOUNT = 'DELETE_ACCOUNT';
exports.ADD_ACCOUNT_PERMISSION = 'ADD_ACCOUNT_PERMISSION';
exports.REMOVE_ACCOUNT_PERMISSION = 'REMOVE_ACCOUNT_PERMISSION';
exports.SET_ACCOUNT_ACCESSIBILITY = 'SET_ACCOUNT_ACCESSIBILITY';
exports.SET_ACCOUNT_ORGANIZATION = 'SET_ACCOUNT_ORGANIZATION';
exports.ADD_ACCOUNT_RELATION = 'ADD_ACCOUNT_RELATION';
exports.REMOVE_ACCOUNT_RELATION = 'REMOVE_ACCOUNT_RELATION';
exports.LOAD_BOOKS = 'LOAD_BOOKS';
exports.LOAD_BOOK = 'LOAD_BOOK';
exports.CREATE_BOOK = 'CREATE_BOOK';
exports.UPDATE_BOOK = 'UPDATE_BOOK';
exports.DELETE_BOOK = 'DELETE_BOOK';
exports.ADD_BOOK_PERMISSION = 'ADD_BOOK_PERMISSION';
exports.REMOVE_BOOK_PERMISSION = 'REMOVE_BOOK_PERMISSION';
exports.SET_BOOK_ACCESSIBILITY = 'SET_BOOK_ACCESSIBILITY';
exports.SET_BOOK_ORGANIZATION = 'SET_BOOK_ORGANIZATION';
exports.ADD_BOOK_RELATION = 'ADD_BOOK_RELATION';
exports.REMOVE_BOOK_RELATION = 'REMOVE_BOOK_RELATION';
exports.LOAD_RECORDS = 'LOAD_RECORDS';
exports.LOAD_RECORD = 'LOAD_RECORD';
exports.CREATE_RECORD = 'CREATE_RECORD';
exports.UPDATE_RECORD = 'UPDATE_RECORD';
exports.DELETE_RECORD = 'DELETE_RECORD';
exports.ADD_RECORD_PERMISSION = 'ADD_RECORD_PERMISSION';
exports.REMOVE_RECORD_PERMISSION = 'REMOVE_RECORD_PERMISSION';
exports.SET_RECORD_ACCESSIBILITY = 'SET_RECORD_ACCESSIBILITY';
exports.SET_RECORD_ORGANIZATION = 'SET_RECORD_ORGANIZATION';
exports.ADD_RECORD_RELATION = 'ADD_RECORD_RELATION';
exports.REMOVE_RECORD_RELATION = 'REMOVE_RECORD_RELATION';
exports.LOAD_TRANSACTIONS = 'LOAD_TRANSACTIONS';
exports.LOAD_TRANSACTION = 'LOAD_TRANSACTION';
exports.CREATE_TRANSACTION = 'CREATE_TRANSACTION';
exports.UPDATE_TRANSACTION = 'UPDATE_TRANSACTION';
exports.DELETE_TRANSACTION = 'DELETE_TRANSACTION';
exports.ADD_TRANSACTION_PERMISSION = 'ADD_TRANSACTION_PERMISSION';
exports.REMOVE_TRANSACTION_PERMISSION = 'REMOVE_TRANSACTION_PERMISSION';
exports.SET_TRANSACTION_ACCESSIBILITY = 'SET_TRANSACTION_ACCESSIBILITY';
exports.SET_TRANSACTION_ORGANIZATION = 'SET_TRANSACTION_ORGANIZATION';
exports.ADD_TRANSACTION_RELATION = 'ADD_TRANSACTION_RELATION';
exports.REMOVE_TRANSACTION_RELATION = 'REMOVE_TRANSACTION_RELATION';